import { motion } from "framer-motion";
import { SOLUTIONS_DELIVERY } from "@/data/content";

export const SolutionsDelivery = () => (
  <section data-testid="solutions-delivery-section" className="bg-surfaceLight px-6 py-[30px] sm:py-[40px] lg:px-12 lg:py-[70px]">
    <div className="lg:mx-auto lg:max-w-[1280px]">
      <div className="max-w-2xl lg:mx-auto lg:text-center">
        <span data-testid="solutions-delivery-eyebrow" className="hidden text-sm font-medium text-teal lg:block">
          FROM ASSESSMENT TO OPERATION
        </span>
        <h2
          data-testid="solutions-delivery-headline"
          className="mt-[7px] font-heading text-[30px] font-semibold leading-tight text-ink sm:text-[35px] lg:mt-3 lg:text-[41px]"
        >
          One system. One process.
        </h2>
      </div>

      <div className="mt-12 grid grid-cols-1 gap-10 sm:grid-cols-2 lg:mt-14 lg:grid-cols-5 lg:gap-8">
        {SOLUTIONS_DELIVERY.map((step, index) => (
          <motion.div
            key={step.n}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.5, delay: index * 0.07 }}
            data-testid={`solutions-delivery-step-${step.n}`}
            className="border-t border-teal/20 pt-6 lg:border-t-2"
          >
            <span className="font-mono text-sm text-teal">{step.n}</span>
            <h3
              data-testid={`solutions-delivery-step-title-${step.n}`}
              className="mt-2 font-heading text-base font-semibold text-ink"
            >
              {step.title}
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-inkSoft">{step.body}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
